import React , { useState , useRef , useEffect } from 'react'


import { Row , Col, Container } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {   faCircleUser, faUser, faXmarkCircle , faFileInvoice , faAngleDown , faCheck, faC} from '@fortawesome/free-solid-svg-icons'
import FormHeader from './FormHeader';

import {faMagnifyingGlass} from '@fortawesome/free-solid-svg-icons'

import axios from 'axios';



function Form1() {

    const [isSelect,setIsSelect] = useState( false )
    const [myData,setMyData] = useState([])
    const [myUsoData,setMyUsoData] = useState([])
    const [showDrop,setShowDrop] = useState( false ) ;
    const [codigoAgrupador,setCodigoAgrupador] = useState( [] )

    const [showCodigo,setShowCodigo] = useState( false ) ;


    function onBack()
    {
        setShowCodigo( false ) ;
    }


    function onDown()
    {        
        var text = document.getElementById("codigotext").value ;


        console.log( "El texto capturado = " + text ) ;


        console.log( "onDown") ;

        showCodigoSelect()
    }


    function showCodigoSelect()
    {

        setShowCodigo( true ) ;



       getCodigoAgrupador() 

    }


    function getCodigoAgrupador()
    {
        var prodList = "" ;

        var list = document.getElementById("codigotext").value ;

        if ( list.trim() === "")
        {
            prodList = ""
        }
        else{
             prodList =  list.split( " ") ;
        }

       

        axios.get( "http://localhost:3004/livefactura/getcodigoagrupador?parms=" + prodList )
        .then( ( response ) => {

            setCodigoAgrupador( response.data ) ;
            return ;

        } )
        .catch((err) => {

            console.log( err ) ;

            return ;

        })

    }

    useEffect(() => {

        var select = document.getElementById('codigo') ;


        if ( select === null || select === undefined)
        {
            console.log( "no encontre el codigo") ;
            return ;
        }


        while( select.length > 0 )
        {
            select.remove( select.length -1 ) ;
        }

        for( var i = 0 ; i < codigoAgrupador.length ; i++)
        {
           

            var option = document.createElement("option");
            option.value = codigoAgrupador[i].codigo ;
            option.text =  codigoAgrupador[i].codigo + "  " + codigoAgrupador[i].nombre  ;
            select.appendChild(option)

        }


    } ,[codigoAgrupador])


    function usoFactura()
    {
        axios.get(  "http://localhost:3004/livefactura/usocfdi" )
        .then( (response) => {


            console.log( "Aqui tenemos la respuesta(usofdi)") ;

            console.log( response.data ) ;

            setMyUsoData( response.data ) ;

            //getCodigoAgrupador() ;
            

        } ) 
        .catch( ( err ) => {

            console.log( "Tenemos un error")
            console.log( err ) ;
        })




    }

    useEffect(() => {

        var select = document.getElementById('uso') ;


        if ( select === null || select === undefined)
        {
            return ;
        }


        while( select.length > 0 )
        {
            select.remove( select.length -1 ) ;
        }

        for( var i = 0 ; i < myUsoData.length ; i++)
        {
           

            var option = document.createElement("option");
            option.value = myUsoData[i].c_usocfdi ;
            option.text = myUsoData[i].c_usocfdi + "   "  + myUsoData[i].descripcion ;
            select.appendChild(option)

        }


    } , [myUsoData])


    useEffect(()=>{

        var salir = false ;

        if ( isSelect === true )
        {
            salir = true ;
        }


        if ( salir === true )
        {
            return ; 
        }



        axios.get(  "http://localhost:3004/livefactura/regimenfiscal" )
        .then( (response) => {


            console.log( "Aqui tenemos la respuesta") ;

            console.log( response.data ) ;

            setMyData( response.data ) ;
            if ( response.data.length > 0 )
            {
                setShowDrop( true ) ;
            }
            else{
                setShowDrop ( false ) ;
            }

            
            

        } ) 
        .catch( ( err ) => {

            console.log( "Tenemos un error")
            console.log( err ) ;
        })
        

    } ,[])


    useEffect(() => {

        var select = document.getElementById('regimen2') ;


         if ( select === null || select === undefined)
         {
             return ;
         }


         while( select.length > 0 )
         {
             select.remove( select.length -1 ) ;
         }

         for( var i = 0 ; i < myData.length ; i++)
         {
            

             var option = document.createElement("option");
             option.value = myData[i].c_regimenfiscal ;
             option.text = myData[i].c_regimenfiscal  + "  " + myData[i].descripcion ;
             select.appendChild(option)

         }
         
         usoFactura() ;

    } , [myData])




  return (
    <>
        <div className="row">
                <div className='col-sm-12'>
                    <label htmlFor="nombre">Nombre / Razon Social</label>
                    <input type="text" class="form-control m-0 p-1"  
                    id="nombre" placeholder="Nombre / Razon Social"/>
                </div>


        </div>


        <div className="row">
                <div className='col-sm-6'>
                    <label htmlFor="rfc">RFC:</label>
                    <input type="text" class="form-control m-0 p-1"  
                    id="rfc" placeholder="RFC:"/>
                </div>

                <div className='col-sm-6'>
                    <label htmlFor="uso">Uso de la Factura:</label>
                    <select class="form-select" id="uso" aria-label="Default select example">
                        <option selected>Seleccionar Uso de la Factura</option>
                        <option value="1">Acreedor</option>
                        <option value="2">Deudor</option>
                    </select>                
                </div>


        </div>


        <div className="row">
            

            
                <div className='col-sm-12'>
                    {
                        !isSelect && (
                            <>

                                <label htmlFor="usoregimen2">Regimen Fiscal:</label>
                                <select class="form-select" id="regimen2" aria-label="Default select example">
                                    <option selected>Seleccionar Uso de la Factura</option>
                                    <option value="1">Op1</option>
                                    <option value="2">Op2</option>
                                </select>


                                {/*                             
                                <label htmlFor="regimen">Regimen Fiscal:</label>
                                <input type="text" class="form-control m-0 p-1"  
                                id="regimen" placeholder="Regimen Fiscal"/> */}
                            
                            </>

                        )
                    }

                    {/* {
                        isSelect && (
                            <>
                                <label htmlFor="usoregimen2">Regimen Fiscal:</label>
                                <select class="form-select" id="regimen2" aria-label="Default select example">
                                    <option selected>Seleccionar Uso de la Factura</option>
                                    <option value="1">Op1</option>
                                    <option value="2">Op2</option>
                                </select>
                            </>           

                        )
                    } */}
                </div>

                {/* <div className='col-sm-1'>
                    <FontAwesomeIcon onClick={onSearchRegimen}  className='pt-2' style={{height:'25px' , marginTop :'25px'}} icon={faMagnifyingGlass} />

                </div> */}
        </div>

        <div className='row'>

            <div className='col-sm-3 mt-2' style={{marginTop :'20px'}}>
                
                    <label htmlFor="tipocuenta">Deudora/Acreedora:</label>
                    <select class="form-select" id="tipocuenta" aria-label="Default select example">
                        <option selected>Seleccionar Tipo Cuenta</option>
                        <option value="A">Acreedor</option>
                        <option value="D">Deudor</option>
                    </select>                
                

            </div>

            <div className='col-sm-3 mt-2'>                
                    <label htmlFor="nivel">Resumen/Detalle:</label>
                    <select class="form-select" id="nivel" aria-label="Default select example">
                        <option value="R">Resumen</option>
                        <option value="D">Detalle</option>
                    </select>                


                    {/* <label htmlFor="nivel">Nivel:</label>
                    <select class="form-select" id="nivel" aria-label="Default select example">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>

                    </select>                 */}
            </div>

            {/* <div className='col-sm-2 mt-2'>

            </div> */}


            <div className='col-sm-6 mt-2'>

                <div style={{position:'relative'}}>

                    {
                        !showCodigo && (

                            <>
                            

                                <div style={{position:'relative'}}>

                                    

                                    <div>
                                        <label htmlFor="codigotext">Código Agrupador:</label>
                                        <input type="text" class="form-control m-0 p-1"  
                                        id="codigotext" placeholder="Código Agrupador:" />
                                    </div>  
                                    <div style={{position:'absolute' , right : '10px' , top : '22px'}}>
                                        <FontAwesomeIcon  className='pt-2 ps-2' onClick={onDown} icon={faAngleDown} 
                                            title='Close' style={{color:'gray' , height:'20px' , width :'15px' }}/>

                                    </div>


                                </div>


                            </>

                            


                        )



                    }


                    {
                        showCodigo && (
                            <>                            
                                <div >

                                    <div style={{display:'inline-block' }}>

                                    
                                        <label htmlFor="codigo">Codigo Agrupador:</label>
                                        <select class="form-select" id="codigo" aria-label="Default select example">
                                            <option value="R">Resumen</option>
                                            <option value="D">Detalle</option>
                                        </select>
                                    </div>


                                    <div style={{display:'inline-block' }}>
                                        <FontAwesomeIcon  onClick={onBack} className='pt-2 ps-2'  icon={faXmarkCircle} 
                                            title='Close' style={{color:'gray' , height:'20px' , width :'15px' }}/>
                                        <FontAwesomeIcon  className='pt-2 ps-2'  icon={faCheck} 
                                            title='Close' style={{color:'gray' , height:'20px' , width :'15px' }}/>

                                    </div >



                                </div>

                            
                            </>

                        


                        )


                    }








                </div>

        


            </div>


        </div>



    


    </>
    
  )
}

export default Form1